import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bz352u88: FaireBrandEntity = {
  token: "b_bz352u88",
  type: "brand",
  name: "Thulisa Naturals™  | Bath + Body",
  avatarUrl:
    "https://cdn.faire.com/fastly/0e539408f41dce7c8f94223447563df41c0b52c4656285f76bc45976e1493f30.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/176c279646479a990ca43bd19aaaf5983a4741147dfdff707c49ef4dfce4d812.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0e539408f41dce7c8f94223447563df41c0b52c4656285f76bc45976e1493f30.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/176c279646479a990ca43bd19aaaf5983a4741147dfdff707c49ef4dfce4d812.jpeg",
  location: "Fairfax, VA, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 95,
  isTopShop: true,
  isInsider: true,
  description:
    "Thulisa Naturals is a women-owned, Leaping Bunny certified wellness brand, handcrafted in small batches in Fairfax, Virginia.\nThe brand was founded by Anusha, a mom and former occupational therapist with 15 years of clinical expertise in sensory processing. It began in her kitchen in 2016, born from a simple need: to turn a hectic daily routine into a moment of calm. By 2019, Thulisa was official — and it remains founder-led and handcrafted to this day.\n\nThat clinical background is the difference. Every shower steamer, body oil, and aromatherapy ritual is built on a real understanding of how scent affects the nervous system — designed to shift how you feel, not just how it smells. Thulisa means \"bringer of peace\" in Zulu, and that's the promise behind every product: small rituals of self-care can change how you move through your day.\n\nThulisa stays small-batch, handcrafted, and cruelty-free because how a product is made matters as much as what it does. And its mission doesn't stop at the shelf — every purchase provides meals to food-insecure preschoolers in South Africa through a partnership with Intsikelelo, a cause woven into the brand's name.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.347Z",
    importedBy: "entity-db-cli",
  },
};
